import {createAction, props} from '@ngrx/store';
import {
  CreateExportConfigErrorDTO,
  ExportConfigDTO,
  ExportConfigStatusDTO
} from '../../../../../openapi/export-openapi';
import {MappedHttpErrorResponse} from '@adnova/jf-ng-components';


export class DatevWizardClientIdActions {

  private static readonly prefix = '[Datev Wizard Client ID]';

  public static setClientId = createAction(
    `${this.prefix} Set client ID`,
    props<{
      clientId: string,
      firmenId: string,
      redirectWhenFinished?: boolean,
    }>(),
  );

  /**
   * Synchronisiert die Client-ID aus der Route, OHNE Navigation auszulösen.
   * Wird von Komponenten verwendet, die IDs aus der Route lesen (z.B. export-date, connection-name).
   */
  public static syncClientIdFromRoute = createAction(
    `${this.prefix} Sync client ID from route`,
    props<{
      clientId: string,
      firmenId: string,
    }>(),
  );

  public static checkIfConfigExists = createAction(
    `${this.prefix} Check if export config exists`,
    props<{
      firmenId: string,
      clientId: string,
      redirectWhenFinished?: boolean,
    }>(),
  );

  public static checkIfConfigExistsSuccess = createAction(
    `${this.prefix} Check if export config exists success`,
    props<{
      firmenId: string,
      clientId: string,
      redirectWhenFinished?: boolean,
      loginUrl?: string,
    }>(),
  );

  public static checkIfConfigExistsFailure = createAction(
    `${this.prefix} Check if export config exists failure`,
    props<{
      firmenId: string,
      clientId: string,
      error: MappedHttpErrorResponse<CreateExportConfigErrorDTO>,
    }>(),
  );

  /**
   * Wird dispatched wenn die Config-Prüfung einen Konflikt (409) ergibt,
   * d.h. die Config existiert bereits. Dies räumt den Loading-State auf
   * und markiert die Prüfung als abgeschlossen.
   */
  public static checkIfConfigExistsWithConflict = createAction(
    `${this.prefix} Check if export config exists with conflict`,
    props<{
      firmenId: string,
      clientId: string,
      exportConfigId?: string,
    }>(),
  );

  public static getExistingExportConfig = createAction(
    `${this.prefix} Get existing export config`,
    props<{
      exportConfigId?: string,
      redirectWhenFinished?: boolean,
    }>(),
  );

  public static getExistingExportConfigSuccess = createAction(
    `${this.prefix} Get existing export config success`,
    props<{
      existingExportConfig: ExportConfigDTO,
      redirectWhenFinished?: boolean,
    }>(),
  );

  public static getExistingExportConfigFailure = createAction(
    `${this.prefix} Get existing export config failure`,
    props<{
      error: MappedHttpErrorResponse,
      exportConfigId?: string,
    }>(),
  );

  public static setExistingExportConfig = createAction(
    `${this.prefix} Set existing export config`,
    props<{
      existingExportConfig: ExportConfigDTO,
      redirectWhenFinished?: boolean,
    }>(),
  );

  public static getExistingExportConfigStatus = createAction(
    `${this.prefix} Get export config status`,
    props<{
      exportConfigId?: string,
      redirectWhenFinished?: boolean,
    }>(),
  );

  public static getExistingExportConfigStatusSuccess = createAction(
    `${this.prefix} Get export config status success`,
    props<{
      existingExportConfigStatus: ExportConfigStatusDTO,
      redirectWhenFinished?: boolean,
    }>(),
  );

  public static getExistingExportConfigStatusFailure = createAction(
    `${this.prefix} Get export config status failure`,
    props<{
      error: MappedHttpErrorResponse,
      exportConfigId?: string,
    }>(),
  );

  public static setExistingExportConfigStatus = createAction(
    `${this.prefix} Set existing export config status`,
    props<{
      existingExportConfigStatus: ExportConfigStatusDTO,
      redirectWhenFinished?: boolean,
    }>(),
  );

  public static goToExportDate = createAction(
    `${this.prefix} Go to export date`,
    props<{
      firmenId: string,
      clientId: string,
    }>(),
  );

  public static connectToDatev = createAction(
    `${this.prefix} Connect to DATEV`,
  );

  public static connectToDatevSuccess = createAction(
    `${this.prefix} Connect to DATEV success`,
    props<{
      loginUrl: string,
    }>(),
  );

  public static connectToDatevFailure = createAction(
    `${this.prefix} Connect to DATEV failure`,
    props<{
      error: MappedHttpErrorResponse,
    }>(),
  );

  public static goToConfigExists = createAction(
    `${this.prefix} Go to config exists`,
    props<{
      firmenId: string,
      clientId: string,
    }>(),
  );

  /**
   * Setzt die gespeicherte existingConfig und existingConfigStatus im Store zurück.
   * Wird aufgerufen, wenn die Konfiguration erfolgreich gelöscht wurde.
   */
  public static resetExistingConfig = createAction(
    `${this.prefix} Reset existing config`,
  );

  /**
   * Aktualisiert den existingExportConfigStatus nach dem Trennen der Verbindung.
   * Setzt connection auf false und entfernt datevClientName, expiration und owner.
   */
  public static updateExportConfigStatusAfterDisconnect = createAction(
    `${this.prefix} Update export config status after disconnect`,
  );

  /**
   * Navigiert zurück zur case-selection Seite.
   */
  public static goBackToCaseSelection = createAction(
    `${this.prefix} Go back to case selection`,
    props<{ firmenId: string }>(),
  );

}
